<template>
  <div>
    <transition-group name="langTrans" mode="out-in">
      <!-- --------------------- ENGLISH --------------------- -->
      <div v-if="english" class="inner" key="english">
        <h1>
          {{ firstName
          }}<span class="lastname" style="cursor: auto; border-bottom: none">{{
            lastName
          }}</span>
        </h1>
        <span class="subtitle">Front-End Developer</span>
        <p>
          I am a french front-end developer specialized in
          <span class="JS">JS</span> framework.
        </p>
        <!-- <div class="technos">
          <div class="frontLang">
            <h2>Front-end</h2>
            <div class="langName">
              <img ondragstart="return false" src="~@/assets/jsLogo.png" />
              <span class="langLevel langLevel80">★★★★★</span>
            </div>
            <div class="langName">
              <img ondragstart="return false" src="~@/assets/vueLogo.png" />
              <span class="langLevel langLevel80">★★★★★</span>
            </div>
            <div class="langName" style="display: flex; align-items: flex-end">
              <img ondragstart="return false" src="~@/assets/angularLogo.png" />
              <span class="langLevel langLevel70">★★★★★</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="backLang">
            <h2>Back-end</h2>
            <div class="langName">
              <img ondragstart="return false" src="~@/assets/nodeLogo.png" />
              <span class="langLevel langLevel70">★★★★★</span>
            </div>
            <div class="langName" style="display: flex; align-items: flex-end">
              <img ondragstart="return false" src="~@/assets/phpLogo.png" />
              <span class="langLevel langLevel80">★★★★★</span>
            </div>
            <div class="langName">
              <img ondragstart="return false" src="~@/assets/pythonLogo.png" />
              <span class="langLevel langLevel60">★★★★★</span>
            </div>
          </div>
        </div> -->
      </div>
      <!-- --------------------- FRENCH --------------------- -->
      <div v-if="!english" class="inner" key="french">
        <h1>
          {{ firstName
          }}<span class="lastname" style="cursor: auto; border-bottom: none"
            >{{ lastName }}
          </span>
        </h1>
        <span class="subtitle">Développeur Front-End</span>
        <p>
          Je suis un développeur Front-End spécialisé en framework
          <span class="JS">JS</span>
        </p>
        <!-- <div class="technos">
          <div class="frontLang">
            <h2>Front-end</h2>
            <div class="langName">
              <img ondragstart="return false" src="~@/assets/jsLogo.png" />
              <span class="langLevel langLevel80">★★★★★</span>
            </div>
            <div class="langName">
              <img ondragstart="return false" src="~@/assets/vueLogo.png" />
              <span class="langLevel langLevel80">★★★★★</span>
            </div>
            <div class="langName" style="display: flex; align-items: flex-end">
              <img ondragstart="return false" src="~@/assets/angularLogo.png" />
              <span class="langLevel langLevel70">★★★★★</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="backLang">
            <h2>Back-end</h2>
            <div class="langName">
              <img ondragstart="return false" src="~@/assets/nodeLogo.png" />
              <span class="langLevel langLevel70">★★★★★</span>
            </div>
            <div class="langName" style="display: flex; align-items: flex-end">
              <img ondragstart="return false" src="~@/assets/phpLogo.png" />
              <span class="langLevel langLevel80">★★★★★</span>
            </div>
            <div class="langName">
              <img ondragstart="return false" src="~@/assets/pythonLogo.png" />
              <span class="langLevel langLevel60">★★★★★</span>
            </div>
          </div>
        </div> -->
      </div>
    </transition-group>
  </div>
</template>

<script>
export default {
  name: "WhoAmI",
  props: {
    english: Boolean,
  },
  data: () => ({
    firstName:
      window.location.hostname == "fratulker.netlify.app" ? "Frat " : "Fra",
    lastName:
      window.location.hostname == "fratulker.netlify.app" ? "ULKER" : "ulk",
  }),
};
</script>

<style scoped>
.inner {
  margin-left: 1em;
}
h1 {
  margin: 0 0.5em;
  margin-bottom: -10px;
}
img {
  width: 25px;
}
.subtitle {
  font-size: 0.9rem;
  padding-top: -5px;
  margin-left: 1.2em;
}
.JS {
  display: inline-flex;
  position: relative;
  justify-content: flex-end;
  align-items: flex-end;
  width: 1.3rem;
  height: 1.3rem;
  font-size: 0.9rem;
  background-color: #e9d44d;
  color: black;
}
.technos {
  display: flex;
  width: 95%;
  justify-content: space-between;
}
.line {
  height: 130px;
  width: 5px;
  margin: auto 0 0 0;
  background-color: var(--primary-dark);
}
.langName {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 7px;
}
.langLevel {
  margin-left: 10px;
}
.langLevel80 {
  background: linear-gradient(
    to right,
    var(--primary) 15%,
    var(--primary-focus) 80%,
    var(--font-color) 0%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.langLevel70 {
  background: linear-gradient(
    to right,
    var(--primary) 15%,
    var(--primary-focus) 70%,
    var(--font-color) 0%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
.langLevel60 {
  background: linear-gradient(
    to right,
    var(--primary) 15%,
    var(--primary-focus) 60%,
    var(--font-color) 0%
  );
  background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>